export const deckTags = [
  { id: 1, name: 'Accounting & Finance' },
  { id: 2, name: 'Aeronautical & Manufacturing Engineering' },
  { id: 3, name: 'Agriculture & Forestry' },
  { id: 4, name: 'American Studies' },
  { id: 5, name: 'Anatomy & Physiology' },
  { id: 6, name: 'Anthropology' },
  { id: 7, name: 'Archaeology' },
  { id: 8, name: 'Architecture' },
  { id: 9, name: 'Art & Design' },
  { id: 10, name: 'Aural & Oral Sciences' },
  { id: 11, name: 'Biological Sciences' },
  { id: 12, name: 'Building' },
  { id: 13, name: 'Business & Management Studies' },
  { id: 14, name: 'Celtic Studies' },
  { id: 15, name: 'Chemical Engineering' },
  { id: 16, name: 'Chemistry' },
  { id: 17, name: 'Civil Engineering' },
  { id: 18, name: 'Classics & Ancient History' },
  { id: 19, name: 'Communication & Media Studies' },
  { id: 20, name: 'Complementary Medicine' },
  { id: 21, name: 'Computer Science' },
  { id: 22, name: 'Counselling' },
  { id: 23, name: 'Creative Writing' },
  { id: 24, name: 'Criminology' },
  { id: 25, name: 'Dentistry' },
  { id: 26, name: 'Drama' },
  { id: 27, name: ' Dance & Cinematics' },
  { id: 28, name: 'East & South Asian Studies' },
  { id: 29, name: 'Economics' },
  { id: 30, name: 'Education' },
  { id: 31, name: 'Electrical & Electronic Engineering' },
  { id: 32, name: 'English' },
  { id: 33, name: 'Fashion' },
  { id: 34, name: 'Film Making' },
  { id: 35, name: 'Food Science' },
  { id: 36, name: 'Forensic Science' },
  { id: 37, name: 'French' },
  { id: 38, name: 'Geography & Environmental Sciences' },
  { id: 39, name: 'Geology' },
  { id: 40, name: 'General Engineering' },
  { id: 41, name: 'German' },
  { id: 42, name: 'History' },
  { id: 43, name: 'History of Art' },
  { id: 44, name: ' Architecture & Design' },
  { id: 45, name: 'Hospitality' },
  { id: 46, name: ' Leisure' },
  { id: 47, name: ' Recreation & Tourism' },
  { id: 48, name: 'Iberian Languages/Hispanic Studies' },
  { id: 49, name: 'Italian' },
  { id: 50, name: 'Land & Property Management' },
  { id: 51, name: 'Law' },
  { id: 52, name: 'Librarianship & Information Management' },
  { id: 53, name: 'Linguistics' },
  { id: 54, name: 'Marketing' },
  { id: 55, name: 'Materials Technology' },
  { id: 56, name: 'Mathematics' },
  { id: 57, name: 'Mechanical Engineering' },
  { id: 58, name: 'Medical Technology' },
  { id: 59, name: 'Medicine' },
  { id: 60, name: 'Middle Eastern & African Studies' },
  { id: 61, name: 'Music' },
  { id: 62, name: 'Nursing' },
  { id: 63, name: 'Occupational Therapy' },
  { id: 64, name: 'Optometry' },
  { id: 65, name: ' Ophthalmology & Orthoptics' },
  { id: 66, name: 'Pharmacology & Pharmacy' },
  { id: 67, name: 'Philosophy' },
  { id: 68, name: 'Physics and Astronomy' },
  { id: 69, name: 'Physiotherapy' },
  { id: 70, name: 'Politics' },
  { id: 71, name: 'Psychology' },
  { id: 72, name: 'Robotics' },
  { id: 73, name: 'Russian & East European Languages' },
  { id: 74, name: 'Social Policy' },
  { id: 75, name: 'Social Work' },
  { id: 76, name: 'Sociology' },
  { id: 77, name: 'Sports Science' },
  { id: 78, name: 'Theology & Religious Studies' },
  { id: 79, name: 'Town & Country Planning and Landscape Design' },
  { id: 80, name: 'Veterinary Medicine' },
  { id: 81, name: 'Youth Work' },
];

export default deckTags;
